import { StoreView } from 'common/types/entities/store'
import { fetchStoreView } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'
const initialState: StoreView = {
  viewCount: 0,
}

const FETCH_VIEW = '/store/general/view/FETCH_VIEW'

export const fetchViewCount = (curState: StateKey, storeId: string) => async dispatch => {
  const result = await fetchStoreView(storeId)

  dispatch({
    curState,
    storeId,
    result,
    type: FETCH_VIEW,
  })
}

const viewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VIEW: {
      return {
        storeId: action.storeId,
        viewCount: action.result.viewCount,
      }
    }
    default:
      return state
  }
}

export default viewReducer
